module.exports = __webpack_public_path__ + "static/media/impactsettings.c5f6e904.PNG";